import axios from "axios";
import store from "@/store";
import { setupResponseInterceptor } from './responseInterceptor';

const tenantClient = axios.create({
  baseURL: process.env.VUE_APP_TENANTS_URL,
  withCredentials: true,
});

tenantClient.interceptors.request.use((config) => {
  config.headers.lang = store.getters["getLang"];
  return config;
});

setupResponseInterceptor(tenantClient);

export default tenantClient; 